import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getCourseVideo } from "../../../actions/course";

const CourseSectionVideo = ({
  video: { _id, poster, videoname },
  course: { channelid, coursetitle },
  id,
  getCourseVideo,
}) => {
  let myString = coursetitle;
  let trimmedString = myString.trim();

  return (
    <Fragment>
      {/* <Link
        to={`/liveonime/mentors/courses/${channelid}/${formattedString}/${id}/${_id}`}
      > */}
      <div
        className="course-video-content-container"
        onClick={() => getCourseVideo(id, channelid, _id)}
      >
        <div className="video-icon-container">
          <ol className="course-videos">
            <img
              src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/course_posters/${poster}`}
              alt="poster"
              className="video-poster "
            />
            <li className="course-video">{videoname}</li>
          </ol>
        </div>
      </div>
      {/* </Link> */}
    </Fragment>
  );
};

CourseSectionVideo.propTypes = {
  auth: PropTypes.object.isRequired,
  getCourseVideo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getCourseVideo })(CourseSectionVideo);
